import * as React from "react";
import {CustomerMessageRoomsState} from "../../../../store/customer_message_rooms_state";
import {ICustomerMessageRoomsDispatcher} from "../../../../dispatcher/customer_message_rooms_dispatcher";
import CustomerMessageRoomCards from "./customer_message_room_cards";

interface IProps {
    messageRoomsState: CustomerMessageRoomsState,
    messageRoomsDispatcher: ICustomerMessageRoomsDispatcher,
    isMessageRooms: boolean,
}

const CustomerMessageRoomsLeft: React.FC<IProps> = (props) => {

    const {messageRoomsState, isMessageRooms} = props;
    const {messageRooms, companyWithProjectIDs, projects, latestMessages, initialMessageRoom} = messageRoomsState

    return (
        <React.Fragment>{
            <CustomerMessageRoomCards
                messageRooms={messageRooms}
                companyWithProjectIDs={companyWithProjectIDs}
                projects={projects}
                latestMessages={latestMessages}
                isMessageRooms={isMessageRooms}
                initialMessageRoom={initialMessageRoom}
              />
        }</React.Fragment>
    )
}

export default CustomerMessageRoomsLeft



// WEBPACK FOOTER //
// ./src/presentation/component/customer/message_rooms/left_side/customer_message_rooms_left.tsx